const BusinessPlane: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="107.241" height="136.197" viewBox="0 0 107.241 136.197">
      <g id="Group_35729" data-name="Group 35729" transform="translate(-1264.298 -906.582)">
        <path
          id="Path_3559"
          data-name="Path 3559"
          d="M104.939,66.834c-.013-.322-42.022-28.411-42.157-28.74A23.127,23.127,0,0,0,61.6,35.945c-1.007-1.847-.658-11.516-.658-15.485,0-9.717-5.513-17.546-7.534-20.1A.954.954,0,0,0,52.67,0a.966.966,0,0,0-.779.356c-2.028,2.558-7.534,10.388-7.534,20.1,0,3.969.349,13.638-.658,15.485a21.677,21.677,0,0,0-1.182,2.149C42.383,38.423.374,66.512.36,66.834c-.128,2.874-.739,11.2-.007,11.019,2.27-.557,42.378-18.11,42.378-18.11s1.309,1.538,2.216,5.681H40.173a2.679,2.679,0,0,0-.833,1.967c.06,1.168.772,11.342.772,11.342L41.792,84.3h2.532l1.269-5.2,2.035-.02,1.679,15.653-10.032,7.635.06,2.3,11.98-.853,1.336,4.459,1.336-4.459,11.98.853.06-2.3L55.994,94.728l1.672-15.653,2.041.02,1.269,5.2h2.532l1.679-5.567s.712-10.173.772-11.342a2.679,2.679,0,0,0-.833-1.967H60.352c.907-4.143,2.216-5.681,2.216-5.681s40.109,17.553,42.378,18.11C105.671,78.035,105.067,69.708,104.939,66.834Z"
          transform="translate(1265.269 907.254)"
          fill="#fff"
        />
        <path
          id="Path_3560"
          data-name="Path 3560"
          d="M0,.094s3.324.994,3.25,1.336-.806,11.691-.806,11.691L.732,18.688H2.256l2.068-5.976S4.365.558,4.324.2,0,.094,0,.094Z"
          transform="translate(1326.521 972.813)"
          fill="#cad7ef"
        />
        <path
          id="Path_3561"
          data-name="Path 3561"
          d="M0,.094s3.331.994,3.25,1.336-.8,11.691-.8,11.691L.732,18.688H2.263l2.061-5.976S4.371.558,4.324.2,0,.094,0,.094Z"
          transform="translate(1307.45 972.813)"
          fill="#cad7ef"
        />
        <path
          id="Path_3562"
          data-name="Path 3562"
          d="M.087,0c0,.2.853,11.892,3.324,13.826s39.215,18.56,39.215,18.56,1.3,2.753-1.39,1.343S0,15.935,0,15.935Z"
          transform="translate(1328.192 951.185)"
          fill="#cad7ef"
        />
        <path
          id="Path_3563"
          data-name="Path 3563"
          d="M42.854,0c0,.2-.853,11.892-3.324,13.826S.314,32.386.314,32.386s-1.3,2.753,1.4,1.343,41.23-17.795,41.23-17.795Z"
          transform="translate(1265.013 951.185)"
          fill="#cad7ef"
        />
        <path
          id="Path_3564"
          data-name="Path 3564"
          d="M1.484,89.007c0-.121,2.35-14.457,3.868-21.387s.933-42.043.933-42.043h.98V22.22h-.98V16.573c0-2.189-1.336-6.446-6.037-6.446L0,0S6.07,8.125,7.266,13.457A60.931,60.931,0,0,1,8.327,26.894c-.107,2.189.134,8.763.134,8.763l.873,1.168L9.4,60.777,7.823,64.5,6.742,66.015,6.426,73.67,3.344,94.957,1.4,93.439Z"
          transform="translate(1317.919 907.031)"
          fill="#cad7ef"
        />
        <path
          id="Path_3565"
          data-name="Path 3565"
          d="M1.947,1.093.224,10.3,0,0Z"
          transform="translate(1319.317 1000.807)"
          fill="#cad7ef"
        />
        <ellipse
          id="Ellipse_57"
          data-name="Ellipse 57"
          cx="18.623"
          cy="3.334"
          rx="18.623"
          ry="3.334"
          transform="translate(1299.294 1036.111)"
          fill="#cad7ef"
        />
        <g id="Group_1272" data-name="Group 1272" transform="translate(1264.298 906.582)">
          <g id="Group_1248" data-name="Group 1248" transform="translate(44.598 0)">
            <path
              id="Path_3566"
              data-name="Path 3566"
              d="M17.383,66.237l-1.309-.282a28.215,28.215,0,0,0,.537-7.622l-.007-37.2c0-9.361-5.164-16.881-7.386-19.682C6.572,4.251,1.4,11.771,1.4,21.132V58.266a28.829,28.829,0,0,0,.571,7.689l-1.309.282a29.54,29.54,0,0,1-.6-8.024V21.132C.058,11.348,5.43,3.525,7.74.611a1.61,1.61,0,0,1,2.525,0c2.31,2.914,7.682,10.737,7.682,20.521V58.266A28.292,28.292,0,0,1,17.383,66.237Z"
              transform="translate(0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1249" data-name="Group 1249" transform="translate(39.553 72.636)">
            <path
              id="Path_3567"
              data-name="Path 3567"
              d="M14.068,38.645l-1.826-6.091L.1,33.427,0,29.768l10.019-7.319C9.8,20.078,8.6,7.185,7.353.235L8.676,0c1.377,7.7,2.7,22.556,2.713,22.7l.034.376L1.363,30.439l.04,1.544,11.812-.846.853,2.834.853-2.834,11.778.846.067-1.551L16.714,23.079l.034-.376C16.761,22.556,18.09,7.722,19.46.02l1.323.235c-1.236,6.957-2.451,19.823-2.666,22.193l10.019,7.326-.148,3.653-12.094-.873Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1250" data-name="Group 1250" transform="translate(39.64 65.424)">
            <path
              id="Path_3568"
              data-name="Path 3568"
              d="M8.36,14.652H.416L0,1.988A1.984,1.984,0,0,1,2.028,0H6.749A1.979,1.979,0,0,1,8.776,1.961ZM1.719,13.309H7.057L7.433,1.941a.633.633,0,0,0-.685-.6H2.028a.639.639,0,0,0-.685.618Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1251" data-name="Group 1251" transform="translate(40.313 67.388)">
            <rect id="Rectangle_652" data-name="Rectangle 652" width="7.43" height="1.343" fill="#545f7f" />
          </g>
          <g id="Group_1252" data-name="Group 1252" transform="translate(40.553 78.733)">
            <path
              id="Path_3569"
              data-name="Path 3569"
              d="M5.271,6.91H1.679L0,0H6.95ZM2.733,5.567H4.217L5.244,1.343H1.706Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1253" data-name="Group 1253" transform="translate(58.825 65.424)">
            <path
              id="Path_3570"
              data-name="Path 3570"
              d="M8.353,14.652H.416L0,1.988A1.984,1.984,0,0,1,2.028,0H6.749A1.973,1.973,0,0,1,8.77,1.961ZM1.719,13.309H7.057L7.433,1.941a.64.64,0,0,0-.685-.6H2.028a.636.636,0,0,0-.685.618Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1254" data-name="Group 1254" transform="translate(59.496 67.388)">
            <rect id="Rectangle_653" data-name="Rectangle 653" width="7.43" height="1.343" fill="#545f7f" />
          </g>
          <g id="Group_1255" data-name="Group 1255" transform="translate(59.731 78.733)">
            <path
              id="Path_3571"
              data-name="Path 3571"
              d="M5.271,6.91H1.685L0,0H6.957ZM2.74,5.567H4.217L5.244,1.343H1.712Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1256" data-name="Group 1256" transform="translate(42.575 35.784)">
            <path
              id="Path_3572"
              data-name="Path 3572"
              d="M2.571,27.209C-.2,26.43-.014,21.38.012,20.81V4.486C.012.336,2.571.013,2.678,0l.141,1.336L2.752.671l.087.665c-.06.007-1.484.262-1.484,3.149V20.843c-.06,1.209.1,4.653,1.578,5.077Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1257" data-name="Group 1257" transform="translate(0 38.9)">
            <path
              id="Path_3573"
              data-name="Path 3573"
              d="M1.136,40.511a1.188,1.188,0,0,1-.645-.195A1.141,1.141,0,0,1,0,39.33l.363-9.743A2.878,2.878,0,0,1,1.647,27.31L42.877,0l.745,1.121-41.23,27.3a1.532,1.532,0,0,0-.685,1.215l-.356,9.421L43.434,20.9l.53,1.236L1.593,40.417A1.091,1.091,0,0,1,1.136,40.511Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1258" data-name="Group 1258" transform="translate(61.732 35.784)">
            <path
              id="Path_3574"
              data-name="Path 3574"
              d="M.363,27.209,0,25.92c1.484-.423,1.638-3.868,1.578-5.043V4.486c0-2.908-1.45-3.149-1.471-3.149L.255,0C.363.013,2.921.336,2.921,4.486V20.843C2.948,21.38,3.136,26.43.363,27.209Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1259" data-name="Group 1259" transform="translate(63.27 38.9)">
            <path
              id="Path_3575"
              data-name="Path 3575"
              d="M42.828,40.511a1.083,1.083,0,0,1-.45-.094L0,22.133.537,20.9,42.62,39.061l-.356-9.421a1.542,1.542,0,0,0-.685-1.215L.349,1.121,1.088,0,42.324,27.31A2.854,2.854,0,0,1,43.6,29.586l.369,9.743a1.131,1.131,0,0,1-.5.987A1.155,1.155,0,0,1,42.828,40.511Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1260" data-name="Group 1260" transform="translate(47.1 9.804)">
            <path
              id="Path_3576"
              data-name="Path 3576"
              d="M12.832,7.306H9.75A5.177,5.177,0,0,0,6.5,6.144,5.019,5.019,0,0,0,3.431,7.165a26.706,26.706,0,0,1-3.264.141L.074,6.742A5.26,5.26,0,0,1,0,5.876C0,2.639,2.921,0,6.5,0S13,2.639,13,5.876a5.346,5.346,0,0,1-.074.873ZM10.207,5.963h1.45A4.893,4.893,0,0,0,6.5,1.343c-2.84,0-5.157,2.035-5.157,4.533A8.2,8.2,0,0,0,2.8,5.963a6.484,6.484,0,0,1,7.407,0Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1261" data-name="Group 1261" transform="translate(52.929 9.966)">
            <rect id="Rectangle_654" data-name="Rectangle 654" width="1.343" height="5.738" fill="#545f7f" />
          </g>
          <g id="Group_1262" data-name="Group 1262" transform="translate(47.856 12.36)">
            <rect
              id="Rectangle_655"
              data-name="Rectangle 655"
              width="1.343"
              height="4.415"
              transform="matrix(0.772, -0.635, 0.635, 0.772, 0, 0.853)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1263" data-name="Group 1263" transform="translate(55.481 12.409)">
            <rect
              id="Rectangle_656"
              data-name="Rectangle 656"
              width="4.275"
              height="1.343"
              transform="translate(0 3.302) rotate(-50.557)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1264" data-name="Group 1264" transform="translate(44.656 21.989)">
            <path
              id="Path_3577"
              data-name="Path 3577"
              d="M0,5.321V.553L1.967.036A1.071,1.071,0,0,1,3.31,1.077V3.622a1.07,1.07,0,0,1-.8,1.034ZM1.343,1.587V3.575l.624-.161V1.426Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1265" data-name="Group 1265" transform="translate(59.234 21.989)">
            <path
              id="Path_3578"
              data-name="Path 3578"
              d="M3.311,5.321.8,4.656A1.07,1.07,0,0,1,0,3.622V1.077A1.056,1.056,0,0,1,.416.224,1.065,1.065,0,0,1,1.343.036L3.311.553ZM1.343,3.414l.624.161V1.587l-.624-.161Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1266" data-name="Group 1266" transform="translate(46.738 30.338)">
            <path
              id="Path_3579"
              data-name="Path 3579"
              d="M.839,3.109A.845.845,0,0,1,0,2.263V.839a.839.839,0,1,1,1.679,0V2.263A.845.845,0,0,1,.839,3.109Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
            <path
              id="Path_3580"
              data-name="Path 3580"
              d="M.839,3.109A.84.84,0,0,1,0,2.27V.839A.844.844,0,0,1,.839,0a.844.844,0,0,1,.839.839V2.27A.84.84,0,0,1,.839,3.109Z"
              transform="translate(0 5.761)"
              fill="#545f7f"
            />
            <path
              id="Path_3581"
              data-name="Path 3581"
              d="M.839,3.1A.84.84,0,0,1,0,2.263V.839a.839.839,0,1,1,1.679,0V2.263A.84.84,0,0,1,.839,3.1Z"
              transform="translate(0 11.53)"
              fill="#545f7f"
            />
            <path
              id="Path_3582"
              data-name="Path 3582"
              d="M.839,3.109A.844.844,0,0,1,0,2.27V.839a.839.839,0,1,1,1.679,0V2.27A.844.844,0,0,1,.839,3.109Z"
              transform="translate(0 17.291)"
              fill="#545f7f"
            />
            <path
              id="Path_3583"
              data-name="Path 3583"
              d="M.839,3.109A.84.84,0,0,1,0,2.27V.846A.845.845,0,0,1,.839,0a.845.845,0,0,1,.839.846V2.27A.84.84,0,0,1,.839,3.109Z"
              transform="translate(0 23.053)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1267" data-name="Group 1267" transform="translate(58.825 30.338)">
            <path
              id="Path_3584"
              data-name="Path 3584"
              d="M.839,3.109A.845.845,0,0,1,0,2.263V.839a.839.839,0,1,1,1.679,0V2.263A.845.845,0,0,1,.839,3.109Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
            <path
              id="Path_3585"
              data-name="Path 3585"
              d="M.839,3.109A.84.84,0,0,1,0,2.27V.839A.844.844,0,0,1,.839,0a.844.844,0,0,1,.839.839V2.27A.84.84,0,0,1,.839,3.109Z"
              transform="translate(0 5.761)"
              fill="#545f7f"
            />
            <path
              id="Path_3586"
              data-name="Path 3586"
              d="M.839,3.1A.84.84,0,0,1,0,2.263V.839a.839.839,0,1,1,1.679,0V2.263A.84.84,0,0,1,.839,3.1Z"
              transform="translate(0 11.53)"
              fill="#545f7f"
            />
            <path
              id="Path_3587"
              data-name="Path 3587"
              d="M.839,3.109A.844.844,0,0,1,0,2.27V.839a.839.839,0,1,1,1.679,0V2.27A.844.844,0,0,1,.839,3.109Z"
              transform="translate(0 17.291)"
              fill="#545f7f"
            />
            <path
              id="Path_3588"
              data-name="Path 3588"
              d="M.839,3.109A.84.84,0,0,1,0,2.27V.846A.845.845,0,0,1,.839,0a.845.845,0,0,1,.839.846V2.27A.84.84,0,0,1,.839,3.109Z"
              transform="translate(0 23.053)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1268" data-name="Group 1268" transform="translate(51.611 80.682)">
            <path
              id="Path_3589"
              data-name="Path 3589"
              d="M4.02,23.8H2.677V8.534L2.01,5.755,1.343,8.534V23.8H0L.019,8.3,2.01,0,4.02,8.455Z"
              transform="translate(0 0)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1269" data-name="Group 1269" transform="translate(52.282 88.465)">
            <rect id="Rectangle_657" data-name="Rectangle 657" width="2.677" height="1.343" fill="#545f7f" />
          </g>
          <g id="Group_1270" data-name="Group 1270" transform="translate(49.985 93.35)">
            <rect
              id="Rectangle_658"
              data-name="Rectangle 658"
              width="2.378"
              height="1.343"
              transform="translate(0 1.444) rotate(-37.403)"
              fill="#545f7f"
            />
          </g>
          <g id="Group_1271" data-name="Group 1271" transform="translate(54.574 93.333)">
            <rect
              id="Rectangle_659"
              data-name="Rectangle 659"
              width="1.342"
              height="2.523"
              transform="translate(0 1.101) rotate(-55.079)"
              fill="#545f7f"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BusinessPlane;
